import React, { useState, useEffect } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useInView } from "react-intersection-observer";
import HeroSection from "./HeroSection";
import WhatYouGet from "./WhatYouGet";
import WhyNowSection from "./WhyNowSection";
import CycleAnimation from "./CycleAnimation";
import ValueProposition from "./ValueProposition";
import KitContents from "./KitContents";
import FAQ from "./FAQ";
import Footer from "./Footer";

const AquaponicsLanding = () => {
  const { scrollYProgress } = useScroll();
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "50%"]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-blue-50">
      {/* Background Pattern */}
      <div className="fixed inset-0 opacity-5 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,_theme(colors.emerald.400)_1px,_transparent_0)] bg-[size:24px_24px]" />
      </div>
      
      <motion.div style={{ y }} className="relative z-10">
        <HeroSection />
        <WhatYouGet />
        <WhyNowSection />
        <CycleAnimation />
        <ValueProposition />
        <KitContents />
        <FAQ />
        <Footer />
      </motion.div>
    </div>
  );
};

export default AquaponicsLanding;